<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer003">
<p class="content-title" id="calibre_toc_4">Glad <br class="calibre2"/>to Be <br class="calibre2"/>Human</p>
<p class="basic-paragraph"><span class="charoverride5"> </span></p>
<p class="basic-paragraph"><span class="charoverride5"> </span></p>
<p class="basic-paragraph"><span class="charoverride5">Adventures in Optimism</span></p>
<p class="basic-paragraph"><span class="charoverride5"> </span></p>
<p class="basic-paragraph"><span class="charoverride5"> </span></p>
<p class="basic-paragraph"><span class="charoverride6">Irene O’Garden</span></p>
<p class="basic-paragraph"><span class="charoverride7"> </span></p>
<p class="basic-paragraph"><span class="charoverride7"> </span></p>
<p class="normal" id="calibre_pb_9"><span class="charoverride8"><img alt="" src="OEBPS/image/MangobzLogo.png"/><br class="calibre3"/></span><span class="charoverride9">Coral Gables</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// GladtoBeHuman_split_004.vue?75ee0a54